module.exports = __webpack_public_path__ + "static/img/label-02.2d861c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/dhl/label-02.png
// module id = A8gg
// module chunks = 31